import getcsvFileKeys from "./entity.utils.js"
const sidebar = true;

const keys = [{
  dataTableID: "course_period_id",
  tooltip: "Course Period ID of this report",
  label: "Course Period ID",
  columnType: "number",
  table: {
    displayOrder: 1
  },
  filter: {
    //chipTitle: "academy_id ~= $input",
    displayOrder: 1,
    columnType: "selectWithQuery",
    dropdown: {
      endPoint: "course_period_reports/by",
      fetchQuery: {
        $where: {
          course_period_id: {
            $ilike: "%$input%"
          }
        }
      },
      label: ['course_period_id'],
      value: 'course_period_id',
      labelSeperator: '',
    },
    filterQuery: {
      $where: {
        course_period_id: {
          $ilike: '%$input%'
        }
      }
    },
    selectedFilterInput: '$input'
  }
},
{
  dataTableID: "course_title",
  tooltip: "Title of the course",
  label: "Course Title",
  columnType: "string",
  table: {
    displayOrder: 2
  },
  filter: {
    chipTitle: "course_title ~= $input",
    displayOrder: 2,
    columnType: "selectWithQuery",
    dropdown: {
      endPoint: "course_period_reports/by",
      fetchQuery: {
        $where: {
          course_title: {
            $ilike: "%$input%"
          }
        }
      },
      label: ['course_title'],
      value: 'course_title',
      labelSeperator: '',
    },
    filterQuery: {
      $where: {
        course_title: {
          $ilike: '%$input%'
        }
      }
    },
    selectedFilterInput: '$input'
  }
},
{
  dataTableID: "academy_id",
  tooltip: "Academy ID associated with this course_period",
  label: "Academy ID",
  columnType: "number",
  create: {
    displayOrder: 1
  },
  table: {
    displayOrder: 3
  },
  filter: {
    chipTitle: "academy_id ~= $input",
    displayOrder: 3,
    columnType: "selectWithQuery",
    dropdown: {
      endPoint: "academies/by",
      fetchQuery: {
        $where: {
          $or: {
            id: {
              $ilike: "%$input%"
            },
            name: {
              $ilike: "%$input%"
            }
          }
        }
      },
      label: ['id', 'name'],
      value: 'id',
      labelSeperator: ' - ',
    },
    filterQuery: {
      $where: {
        academy_id: {
          $ilike: '%$input%'
        }
      }
    },
    selectedFilterInput: '$input'
  }
},
{
  dataTableID: "academy_name",
  tooltip: "Academy Name for this record",
  label: "Academy Name",
  columnType: "string",
  create: {
    displayOrder: 2
  },
  table: {
    displayOrder: 4
  }
},
{
  dataTableID: "user_id",
  tooltip: "User ID associated with this course_period",
  label: "User ID",
  columnType: "number",
  create: {
    displayOrder: 3
  },
  table: {
    displayOrder: 5
  },
  filter: {
    chipTitle: "user_id ~= $input",
    displayOrder: 5,
    columnType: "selectWithQuery",
    dropdown: {
      endPoint: "users/by",
      fetchQuery: {
        $where: {
          $or: {
            id: {
              $ilike: "%$input%"
            },
            name: {
              $ilike: "%$input%"
            }
          }
        }
      },
      label: ['id', 'name'],
      value: 'id',
      labelSeperator: ' - ',
    },
    filterQuery: {
      $where: {
        user_id: {
          $ilike: '%$input%'
        }
      }
    },
    selectedFilterInput: '$input'
  }
},
{
  dataTableID: "user_name",
  tooltip: "Username of the user",
  label: "User Name",
  columnType: "string",
  create: {
    displayOrder: 4
  },
  table: {
    displayOrder: 6
  }
},
{
  dataTableID: "first_name",
  tooltip: "First name of the user",
  label: "First Name",
  columnType: "number",
  create: {
    displayOrder: 5
  },
  table: {
    displayOrder: 7
  },
  filter: {
    displayOrder: 7
  }
},
{
  dataTableID: "last_name",
  tooltip: "Last name of the user",
  label: "Last Name",
  columnType: "number",
  create: {
    displayOrder: 6
  },
  table: {
    displayOrder: 8
  },
  filter: {
    displayOrder: 8
  }
},
{
  dataTableID: "email",
  tooltip: "Email of the user",
  label: "Email",
  columnType: "string",
  create: {
    displayOrder: 7
  },
  table: {
    displayOrder: 9
  },
  filter: {
    chipTitle: "user_id ~= $input",
    displayOrder: 9,
    columnType: "selectWithQuery",
    dropdown: {
      endPoint: "users/by",
      fetchQuery: {
        $where: {
          $or: {
            id: {
              $ilike: "%$input%"
            },
            email: {
              $ilike: "%$input%"
            }
          }
        }
      },
      label: ['id', 'email'],
      value: 'id',
      labelSeperator: ' - ',
    },
    filterQuery: {
      $where: {
        user_id: {
          $ilike: '%$input%'
        }
      }
    },
    selectedFilterInput: '$input'
  }
},
{
  dataTableID: "gender",
  tooltip: "Gender of the user",
  label: "Gender",
  columnType: "string",
  create: {
    displayOrder: 8
  },
  table: {
    displayOrder: 10
  },
  filter: {
    chipTitle: "gender = $input",
    displayOrder: 10,
    columnType: "selectWithQuery",
    dropdown: {
      endPoint: 'course_period_reports/by',
      fetchQuery: {
        $distinct: "gender",
        $where: {
          gender: {
            $ilike: "%$input%"
          }
        }
      },
      label: ['gender'],
      value: 'gender',
      labelSeperator: '',
    },
    filterQuery: {
      $where: {
        gender: '$input'
      }
    },
    selectedFilterInput: '$input'
  }
},
{
  dataTableID: "group_label",
  tooltip: "Group label of the user",
  label: "Group Label",
  columnType: "number",
  create: {
    displayOrder: 9
  },
  table: {
    displayOrder: 11
  },
  filter: {
    displayOrder: 11
  }
},
{
  dataTableID: "enrollment_created_at",
  tooltip: "When was the enrollment created?",
  label: "Enrollment Created At",
  columnType: "date",
  create: {
    displayOrder: 10
  },
  table: {
    displayOrder: 12
  },
  filter: {
    displayOrder: 12,
    columnType: "dateTimeRange"
  }
},
{
  dataTableID: "buddy_name",
  tooltip: "Name of the buddy",
  label: "Buddy Name",
  columnType: "string",
  create: {
    displayOrder: 11
  },
  table: {
    displayOrder: 13
  },
  filter: {
    displayOrder: 13
  }
},
{
  dataTableID: "buddy_email",
  tooltip: "Email of the buddy",
  label: "Buddy Email",
  columnType: "string",
  create: {
    displayOrder: 12
  },
  table: {
    displayOrder: 14
  },
  filter: {
    displayOrder: 14
  }
},
{
  dataTableID: "is_course_completed",
  tooltip: "Whether the course is completed or not?",
  label: "Is Course Completed",
  columnType: "boolean",
  create: {
    displayOrder: 13
  },
  table: {
    displayOrder: 15
  },
  filter: {
    displayOrder: 15,
    chipTitle: "is_course_completed = $input",
    columnType: "selectWithCustomQuery",
    dropdown: {
      items: [
        {
          label: 'True',
          value: true
        },
        {
          label: 'False',
          value: false
        }
      ]
    },
    filterQueries: {
      true: {
        $where: {
          'is_course_completed': true
        }
      },
      false: {
        $where: {
          'is_course_completed': false
        }
      }
    }
  },
},
{
  dataTableID: "pre_assessment_score",
  tooltip: "Preassessment score of this course period",
  label: "Pre-Assessment Score",
  columnType: "number",
  create: {
    displayOrder: 14
  },
  table: {
    displayOrder: 16
  },
  filter: {
    displayOrder: 16,
    columnType: "integerRange"
  }
},
{
  dataTableID: "unit_one_score",
  tooltip: "Score of the unit one",
  label: "Unit One Score",
  columnType: "number",
  create: {
    displayOrder: 15
  },
  table: {
    displayOrder: 17
  },
  filter: {
    displayOrder: 17,
    columnType: "integerRange"
  }
},
{
  dataTableID: "unit_two_score",
  tooltip: "Score of the unit two",
  label: "Unit Two Score",
  columnType: "number",
  create: {
    displayOrder: 16
  },
  table: {
    displayOrder: 18
  },
  filter: {
    displayOrder: 18,
    columnType: "integerRange"
  }
},
{
  dataTableID: "unit_three_score",
  tooltip: "Score of the unit three",
  label: "Unit Three Score",
  columnType: "number",
  create: {
    displayOrder: 17
  },
  table: {
    displayOrder: 19
  },
  filter: {
    displayOrder: 19,
    columnType: "integerRange"
  }
},
{
  dataTableID: "unit_four_score",
  tooltip: "Score of the unit four",
  label: "Unit Four Score",
  columnType: "number",
  create: {
    displayOrder: 18
  },
  table: {
    displayOrder: 20
  },
  filter: {
    displayOrder: 20,
    columnType: "integerRange"
  }
},
{
  dataTableID: "unit_five_score",
  tooltip: "Score of the unit five",
  label: "Unit Five Score",
  columnType: "number",
  create: {
    displayOrder: 19
  },
  table: {
    displayOrder: 21
  },
  filter: {
    displayOrder: 21,
    columnType: "integerRange"
  }
},
{
  dataTableID: "unit_six_score",
  tooltip: "Score of the unit six",
  label: "Unit Six Score",
  columnType: "number",
  create: {
    displayOrder: 20
  },
  table: {
    displayOrder: 22
  },
  filter: {
    displayOrder: 22,
    columnType: "integerRange"
  }
},
{
  dataTableID: "unit_seven_score",
  tooltip: "Score of the unit seven",
  label: "Unit Seven Score",
  columnType: "number",
  create: {
    displayOrder: 21
  },
  table: {
    displayOrder: 23
  },
  filter: {
    displayOrder: 23,
    columnType: "integerRange"
  }
},
{
  dataTableID: "unit_eight_score",
  tooltip: "Score of the unit eight",
  label: "Unit Eight Score",
  columnType: "number",
  create: {
    displayOrder: 22
  },
  table: {
    displayOrder: 24
  },
  filter: {
    displayOrder: 24,
    columnType: "integerRange"
  }
},
{
  dataTableID: "unit_nine_score",
  tooltip: "Score of the unit nine",
  label: "Unit Nine Score",
  columnType: "number",
  create: {
    displayOrder: 23
  },
  table: {
    displayOrder: 25
  },
  filter: {
    displayOrder: 25,
    columnType: "integerRange"
  }
},
{
  dataTableID: "unit_ten_score",
  tooltip: "Score of the unit ten",
  label: "Unit Ten Score",
  columnType: "number",
  create: {
    displayOrder: 24
  },
  table: {
    displayOrder: 26
  },
  filter: {
    displayOrder: 26,
    columnType: "integerRange"
  }
},
{
  dataTableID: "assignment_status",
  tooltip: "Status of the assignment",
  label: "Assignmnet Status",
  columnType: "string",
  create: {
    displayOrder: 25
  },
  table: {
    displayOrder: 27
  },
  filter: {
    displayOrder: 27,
    chipTitle: "assignment_status = $input",
    columnType: "selectWithStaticValues",
    dropdown: {
      items: [
        'accepted',
        'rejected',
        'sent'
      ]
    },
    filterQuery: {
      $where: {
        assignment_status: '$input'
      }
    },
    selectedFilterInput: '$input'
  }
},
{
  dataTableID: "assignment_score",
  tooltip: "Score of the assignment",
  label: "Assignment Score",
  columnType: "number",
  create: {
    displayOrder: 26
  },
  table: {
    displayOrder: 28
  },
  filter: {
    displayOrder: 28,
    columnType: "integerRange"
  }
},
{
  dataTableID: "status",
  tooltip: "Status of the course period",
  label: "Status",
  columnType: "number",
  create: {
    displayOrder: 27
  },
  table: {
    displayOrder: 29
  },
  filter: {
    displayOrder: 29,
    chipTitle: "status = $input",
    columnType: "selectWithStaticValues",
    dropdown: {
      items: [
        'Business Member',
        'Member',
        'Non-Member'
      ]
    },
    filterQuery: {
      $where: {
        status: '$input'
      }
    },
    selectedFilterInput: '$input'
  }
},
{
  dataTableID: "last_sign_in_at",
  tooltip: "Time of the last sign in",
  label: "Last Sign in At",
  columnType: "date",
  create: {
    displayOrder: 28
  },
  table: {
    displayOrder: 30
  },
  filter: {
    displayOrder: 30,
    columnType: "dateTimeRange"
  }
},
{
  dataTableID: "sign_in_count",
  tooltip: "Number of sign in",
  label: "Sign In Count ",
  columnType: "number",
  create: {
    displayOrder: 29
  },
  table: {
    displayOrder: 31
  },
  filter: {
    displayOrder: 31,
    columnType: "integerRange"
  }
},
{
  dataTableID: "downloads_count",
  tooltip: "Number of downloads",
  label: "Downloads Count",
  columnType: "number",
  create: {
    displayOrder: 30
  },
  table: {
    displayOrder: 32
  },
  filter: {
    displayOrder: 32,
    columnType: "integerRange"
  }
},
{
  dataTableID: "posts_count",
  tooltip: "Number of posts",
  label: "Posts Count",
  columnType: "number",
  create: {
    displayOrder: 31
  },
  table: {
    displayOrder: 33
  },
  filter: {
    displayOrder: 33,
    columnType: "integerRange"
  }
},
{
  dataTableID: "likes_count",
  tooltip: "Number of likes",
  label: "Likes Count",
  columnType: "number",
  create: {
    displayOrder: 32
  },
  table: {
    displayOrder: 34
  },
  filter: {
    displayOrder: 34,
    columnType: "integerRange"
  }
},
{
  dataTableID: "comments_count",
  tooltip: "Number of comments",
  label: "Comments Count",
  columnType: "number",
  create: {
    displayOrder: 33
  },
  table: {
    displayOrder: 35
  },
  filter: {
    displayOrder: 35,
    columnType: "integerRange"
  }
},
{
  dataTableID: "final_score",
  tooltip: "Final score",
  label: "Final Score",
  columnType: "number",
  create: {
    displayOrder: 34
  },
  table: {
    displayOrder: 36
  },
  filter: {
    displayOrder: 36,
    columnType: "integerRange"
  }
},
{
  dataTableID: "final_result",
  tooltip: "Final result",
  label: "Final Result",
  columnType: "number",
  create: {
    displayOrder: 35
  },
  table: {
    displayOrder: 37
  },
  filter: {
    displayOrder: 37,
    columnType: "integerRange"
  }
},

{
  dataTableID: "improvement_percentage",
  tooltip: "Improvement percentage of this course period",
  label: "Improvement Percentage",
  columnType: "number",
  create: {
    displayOrder: 36
  },
  table: {
    displayOrder: 38
  },
  filter: {
    displayOrder: 38,
    columnType: "integerRange"
  }
},
{
  dataTableID: "inserted_at",
  tooltip: "When was this record created?",
  label: "Inserted At",
  columnType: "date",
  create: {
    displayOrder: 37
  },
  table: {
    displayOrder: 39
  },
  filter: {
    displayOrder: 39,
    columnType: "dateTimeRange"
  }
},
{
  dataTableID: "updated_at",
  tooltip: "When was this record updated?",
  label: "Updated At",
  columnType: "date",
  create: {
    displayOrder: 38
  },
  table: {
    displayOrder: 40
  },
  filter: {
    displayOrder: 40,
    columnType: "dateTimeRange"
  }
},
{
  dataTableID: "last_processed_at",
  tooltip: "When was this record last processed?",
  label: "Last Processed At",
  columnType: "date",
  create: {
    displayOrder: 39
  },
  table: {
    displayOrder: 41
  },
  filter: {
    displayOrder: 41,
    columnType: "dateTimeRange"
  }
}
];

const tabs = [{
  view: "detailView",
  entity: "tools",
  endPoint: "tools/by",
  title: "Details",
  queryFilter: {
    id: ":id"
  }
}];

const entity = {
  title: "Course Period User Summary Reports",
  name: "course_period_reports",
  actions: {
    sort: {
      endPoint: "course_period_reports/by",
      query: {
        $order: {},
      }
    },
    get: {
      endPoint: "course_period_reports/by",
      query: {}
    },
    create: {
      endPoint: "course_period_reports"
    },
    filter: {
      endPoint: "course_period_reports/by",
      query: {
        $group: "id",
        $where: {}
      }
    },
    csvDownload: {
      endPoint: "course_period_reports/csv_by",
      query: {
        $group: "id",
        $where: {},
        csvFileKeys: getcsvFileKeys(keys)
      }
    },
    csvEmail: {
      endPoint: "course_period_reports/background_csv_by",
      query: {
        $group: "id",
        $where: {},
        csvFileKeys: getcsvFileKeys(keys)
      }
    },
    tenant: {
      endPoint: "academies/by",
      query: {},
      searchQuery: "name",
      inHeaderValue: "id",
      headerName: "X-Academies",
      name: "Academies",
    }
  }
};

export {
  sidebar,
  entity,
  keys,
  tabs
};
